import { withMotion } from '../hoc/with-motion';
import { RecordingSessionViewer } from '@/modules/manager/components/org/recording-session/viewer';

const AnimatedPage = withMotion(RecordingSessionViewer);

export const roles: string[] = [];
export const path = '/manager/:orgId/recording/:sessionId';
export const element = <AnimatedPage />